export const requireEnv = (key: string): string => {
  const value = import.meta.env[key];
  if (typeof value !== 'string' || value.trim() === '') {
    throw new Error(
      `Missing required environment variable: ${key}. Check your .env configuration.`
    );
  }
  return value.trim();
};

export const optionalEnv = (key: string): string | undefined => {
  const value = import.meta.env[key];
  if (typeof value !== 'string' || value.trim() === '') return undefined;
  return value.trim();
};
